/* eslint-disable wrap-regex */
import axios from 'axios'
import { appEnvironment, NONE_VALUE } from '../constants'
import { Logger, LoggerTypes } from '../utils'

/**
 * Delay function execution.
 *
 * @param {function} fn Function to execute.
 * @param {number} timeout Time to delay in milliseconds.
 * @returns {function}
 **/
const debounce = (fn, timeout) => {
  let timer
  return () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, timeout)
  }
}

/**
 * Check if the email is valid.
 *
 * @param {string} email Email to check
 * @returns {boolean}
 */
const isValidEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

/**
 * Get file content.
 *
 * @param {string} file Path or URL of the file content to get.
 * @returns {Promise<T>}
 */
const getFileContent = async (file) => {
  Logger.trace(LoggerTypes.DEFAULT, 'utils.getFileContent()', { file })
  return await axios.get(file)
}

// -- this constant allows to witch off the debug view.
const IS_DEBUG = false

/**
 * Control is the current environment is under `development`.
 * The global environment var `NODE_ENV` define this status.
 *
 * @returns {boolean}
 */
const isDebug = () => process.env.NODE_ENV === appEnvironment.DEVELOPMENT && IS_DEBUG

const getEnvValue = (envName) => {
  // if (process.env.NODE_ENV === appEnvironment.DEVELOPMENT) {
  return process.env[`REACT_APP_${envName}`]
  // }
  // return process.env[envName]
}

const controlAxiosResponse = (enqueueSnackbar, t, res) => {
  if (res && res?.data && res?.data?.isAxiosError) {
    enqueueSnackbar(t('common.api_failure'), {
      variant: 'error',
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' }
    })
  }
}

const checkResponse = (res, enqueueSnackbar, t, message) => {
  if (res && res?.data && !res?.data?.isAxiosError) {
    const msg_value = t(message)
    if (msg_value) {
      enqueueSnackbar(msg_value, {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' }
      })
    } else {
      Logger.error(LoggerTypes.DEFAULT, 'utils.checkResponse() - Invalid message', { message })
    }
  } else {
    controlAxiosResponse(enqueueSnackbar, t, res)
  }
}

const checkCreateResponse = (res, enqueueSnackbar, t) => {
  checkResponse(res, enqueueSnackbar, t, 'common.api_create_success')
}

const checkUpdateResponse = (res, enqueueSnackbar, t) => {
  checkResponse(res, enqueueSnackbar, t, 'common.api_edit_success')
}

// const checkSnackbarOK = (enqueueSnackbar, t, res) => {
//   if (res && res?.data && !res?.data?.isAxiosError) {
//     enqueueSnackbar(t('common.api_success'), { variant: 'success' })
//   } else {
//     controlAxiosResponse(enqueueSnackbar, t, res)
//   }
// }

// const checkSnackbarKO = (enqueueSnackbar, t, res) => {
const checkErrorResponse = (res, enqueueSnackbar, t) => {
  const error = res?.response?.data?.error || null

  enqueueSnackbar(`${t('common.api_failure')} ${error ? error : ''}`, {
    variant: 'error',
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' }
  })

  if (!error) {
    controlAxiosResponse(enqueueSnackbar, t, res)
  }
}

const ucFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1)
}

/**
 * Clear multidimensional object and remove null or empty attribute.
 * Convert attribute that have as value '' to null
 *
 * @param {object} obj Object to clear
 * @returns {object}
 */
const clearData = (obj) => {
  // -- Recursively remove `undefined` of `null` value in the multidimensional `obj` Object
  Object.keys(obj).forEach(
    (key) =>
      (obj[key] && typeof obj[key] === 'object' && clearData(obj[key])) ||
      ((obj[key] === undefined || obj[key] === null) && delete obj[key])
  )
  // -- Recursively replace empty string attribute `''` or `NONE` by `null` value.
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object' && clearData(obj[key])) {
      // -- continue recursively
    } else if (obj[key] === NONE_VALUE || obj[key] === '') {
      obj[key] = null
    }
  })
  return obj
}

const truncate = (str, len, sufix = '...') => {
  return typeof str === 'string' && str.length > len ? `${str.substring(0, len)}${sufix}` : str
}

/**
 * This methos is used to replace spaces characters by _ in the name of attributes.
 * @param {string} name to check and replace ' ' by '_'.
 * @returns {string} Reformated name.
 */
const removeSpace = (name) => (name && name.replaceAll(' ', '_')) || name

export {
  debounce,
  isValidEmail,
  getFileContent,
  isDebug,
  getEnvValue,
  checkCreateResponse,
  checkUpdateResponse,
  checkErrorResponse,
  // checkSnackbarOK,
  // checkSnackbarKO,
  ucFirst,
  clearData,
  truncate,
  removeSpace
}
